import React, { useState } from 'react';
import './CustomCalendar.css';

const CustomCalendar = ({ isOpen, onClose, onDateSelect, selectedDate, theme = 'dark' }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  
  if (!isOpen) return null;

  const today = new Date();
  const firstDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
  const lastDay = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);
  const startDate = new Date(firstDay);
  startDate.setDate(startDate.getDate() - firstDay.getDay());

  const monthNames = [
    'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
    'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
  ];

  const dayNames = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

  const goToPreviousMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1));
  };

  const goToNextMonth = () => {
    setCurrentMonth(new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1));
  };

  const handleDateClick = (date) => {
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    const formattedDate = `${day}/${month}/${year}`;
    onDateSelect(formattedDate);
    onClose();
  };

  const generateCalendarDays = () => {
    const days = [];
    const current = new Date(startDate);
    
    for (let i = 0; i < 42; i++) {
      const isCurrentMonth = current.getMonth() === currentMonth.getMonth();
      const isToday = current.toDateString() === today.toDateString();
      const isSelected = selectedDate && 
        current.toDateString() === new Date(selectedDate.split('/').reverse().join('-')).toDateString();
      
      days.push({
        date: new Date(current),
        day: current.getDate(),
        isCurrentMonth,
        isToday,
        isSelected
      });
      
      current.setDate(current.getDate() + 1);
    }
    
    return days;
  };

  return (
    <div className="calendar-overlay" data-testid="custom-calendar">
      <div className={`calendar-content theme-${theme}`}>
        {/* Header */}
        <div className="calendar-header">
          <button onClick={goToPreviousMonth} className="nav-button">
            ‹
          </button>
          <h3 className="month-year">
            {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
          </h3>
          <button onClick={goToNextMonth} className="nav-button">
            ›
          </button>
          <button onClick={onClose} className="close-button" data-testid="close-calendar">
            ✕
          </button>
        </div>

        {/* Days Header */}
        <div className="days-header">
          {dayNames.map(day => (
            <div key={day} className="day-header">{day}</div>
          ))}
        </div>

        {/* Calendar Grid */}
        <div className="calendar-grid">
          {generateCalendarDays().map((dayObj, index) => (
            <button
              key={index}
              onClick={() => handleDateClick(dayObj.date)}
              className={`calendar-day ${
                dayObj.isCurrentMonth ? 'current-month' : 'other-month'
              } ${
                dayObj.isToday ? 'today' : ''
              } ${
                dayObj.isSelected ? 'selected' : ''
              }`}
              data-testid={`calendar-day-${dayObj.day}`}
            >
              {dayObj.day}
            </button>
          ))}
        </div>

        {/* Footer */}
        <div className="calendar-footer">
          <button onClick={() => handleDateClick(today)} className="today-button">
            Hoy: {today.getDate()}/{today.getMonth() + 1}/{today.getFullYear()}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomCalendar;